import * as Actions from './actions/actions';
import reducer from './reducers/index';
import { processResponse, getResponseActionsNamed } from '@alme/ui-web/ref/lib-response-handler';
export default class FormInteractionResponseHandler {

    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;
    }

    getReducer() {
        return reducer;
   }

   process(message){
        return processResponse(message, {
            processArray: this.processArray.bind(this),
            processSingle: this.processResponse.bind(this),
            responseActionName: this._settings.responseActionConstants.formInteractionResponseActionName,
        });
    }

    wasProcessed(response) {
        // AMTRAK-3953 - Check whether processed already
        const { Base, EntryId } = this._settings.stateLocations.FormInteraction;
        const state = this._store.getState();
        const savedEntryId = state[Base][EntryId];
        return this.getEntryId(response) === savedEntryId;
    }

    doesNavigate(response) {
        return response && 
            response.navUrl &&
            response.navUrl.AutoNavigationType !== "None";
    }

    getLastHistoryMessage(history) {
        // An array (history)
        const historyLength = history.response.length,
            response = history.response[historyLength - 1];

        return {
            messageType: 'HistoryItem',
            response,
        };
    }

    getEntryId(response) {
        const actions = getResponseActionsNamed(
            response, 
            this._settings.responseActionConstants.entryIdResponseActionName || "EntryId"
        );

        return !actions || actions.length != 1 ? null : actions[0].Value;
    }

    processArray(messages){
        const lastMessage = this.getLastHistoryMessage(messages);

        if (
            this.doesNavigate(lastMessage.response) && 
            !this.wasProcessed(lastMessage.response)
        ) {
            this.processResponse(lastMessage.response);
        }

        return messages;
    }

    processResponse(response) {
        const formInteractions = getResponseActionsNamed(
            response, 
            this._settings.responseActionConstants.formInteractionResponseActionName
        );

        // This stores the last selector successfully interacted with. 
        // This is useful to verify submission of form data.
        let lastSelector = null;

        //https://codeburst.io/javascript-async-await-with-foreach-b6ba62bbf404
        //There was a change on the page so that the elements within the dropdown only
        //exist once the dropdown is visible. Because of this we need to wait for each 
        //command to finish before the next one is executed AWJ-400
        async function asyncForEach(array, callback) {
            for (const element in array) {
                await callback(array[element]);
            }
        }

        // Iterate over response action elements; try
        // to interact with elements accordingly
       const start = async () => {
            // eslint-disable-next-line @typescript-eslint/require-await
            await asyncForEach(formInteractions, async (interaction) => {
                const { Selector, Type, Value } = interaction;

                // Don't try to use bad selectors!
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                if (!validSelector(Selector)) {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    log(`Invalid selector: '${Selector}'`);
                    return;
                }

                const element = this.querySelector(Selector);

                // Bail if not found.
                if (!element) { 
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    log(`"${Selector}" yielded no elements.`);
                    return;
                }

                // Use if no matching handler found.
                const defaultHandler = () => { 
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    log(`Unrecognized "${Type}" interaction.`); 
                };

                // Find right handler based on Type
                await ({
                    "Click": () => { 
                        element.click();
                        lastSelector = Selector;
                    },
                    "SetValue": () => { 
                        element.value = Value;
                        lastSelector = Selector;
                    },
                }[Type] || defaultHandler)();
            });
       };

       start();
        
        if (lastSelector) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            log(`Last interaction was on element "${lastSelector}".`);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            log(`No interactions performed.`);
        }

        this._store.dispatch(Actions.setLastEntryId(this.getEntryId(response)));

        function log(str) {
            console && console.log(str);
        }

        function validSelector(selector) {
            return !!selector;
        }

        return response;
    }

    querySelector(query) {
        return window.document.querySelector(query);
    }
}


// WEBPACK FOOTER //
// ./components/response-handlers/form-interaction/response-handler-form-interaction.js